import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Checkbox, ListItemText } from '@mui/material';
import { Option } from '../../../models/component-models/ComponentModels';

interface MultiSelectProps {
  options: Option[];
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
}

export const MultiSelect: React.FC<MultiSelectProps> = ({
  options,
  value,
  onChange,
  label,
  placeholder,
  error,
  disabled,
}) => {
  const selectId = label || placeholder
    ? `${(label || placeholder)!.replace(/\s+/g, '-').toLowerCase()}-multiselect`
    : undefined;

  const handleChange = (event: any) => {
    const newValue = event.target.value;
    // Material-UI Select multiple modunda string[] döner
    onChange(typeof newValue === 'string' ? newValue.split(',') : newValue);
  };

  const renderValue = (selected: string[]) => {
    if (selected.length === 0) {
      return placeholder || '';
    }
    if (selected.length === 1) {
      const option = options.find(opt => opt.value === selected[0]);
      return option?.label || selected[0];
    }
    return `${selected.length} seçili`;
  };

  return (
    <FormControl
      fullWidth
      error={!!error}
      disabled={disabled}
      variant="outlined"
      size="small"
    >
      {(label || placeholder) && (
        <InputLabel id={`${selectId}-label`}>{label || placeholder}</InputLabel>
      )}
      <Select
        labelId={`${selectId}-label`}
        id={selectId}
        multiple
        value={value}
        onChange={handleChange}
        label={label || placeholder}
        renderValue={renderValue}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={value.includes(option.value)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
